import { TalentDashboardErrorBoundary } from '@/views/dashboards-v2/talent/talent-dashboard-content.error';

export default TalentDashboardErrorBoundary;
